import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const obtenerTurnoParaAtender = async ({ id, token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.ADP.TURNOS.OBTENER_PARA_ATENDER}${id}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default obtenerTurnoParaAtender;